// extracted by mini-css-extract-plugin
export default {"certificateImage":"style_certificateImage__47AJD"};